<template>
  <transition name="fade-in-leave">
    <router-view/>
  </transition>
</template>

<script>
export default {
  name: "routerContainer"
}
</script>

<style scoped>

</style>